import React, { useMemo } from 'react';
import { ToolbarBtn } from './FlowToolbar/ToolbarButton';

const BracesIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1" />
    <path d="M16 3h1a2 2 0 0 1 2 2v5a2 2 0 0 0 2 2 2 2 0 0 0-2 2v5a2 2 0 0 1-2 2h-1" />
  </svg>
);

/**
 * Campaign variables button. Parent must wrap with ResponsiveToolbar.Item
 * directly — the overflow menu clones Item.props.children.
 */
const VariablesToolbarItem = ({ onManageVariables }) => {
  const iconEl = useMemo(() => <BracesIcon />, []);
  return (
    <ToolbarBtn
      icon={iconEl}
      label="Variables"
      onClick={onManageVariables}
      title="Campaign variables — values docs in this campaign can use"
    />
  );
};

export default VariablesToolbarItem;
